import { useEffect, useState } from "react";

/**
 * A custom hook that determines if the code is running on the client side.
 * So window related functions and object can be used.
 *
 * @returns {boolean} - Returns true if on the client side, false otherwise.
 */
const useClientSide = () => {
  const [isClientSide, setIsClientSide] = useState(false);

  useEffect(function onLoad() {
    if (typeof window !== "undefined") {
      setIsClientSide(true);
    }
  }, []);

  return isClientSide;
};

export default useClientSide;
